export const Colors = {
  background: {
    DEFAULT: '#09090B',
    gradient: '#FC9512',
    variant: '#1E1E1E',
    grey: '#3F3F46',
    dark: '#18181B',
  },
  foreground: '#ffffff',
  section: '#1B2026',
  footer: '#09090b',
  primary: {
    DEFAULT: '#FAC938',
    hover: '#FAC938',
    text: '#FAC938',
    foreground: '#000000',
  },
  secondary: {
    DEFAULT: '#4ADE80',
    hover: '#379160',
    text: '#32C275',
    foreground: '#ffffff',
    variant: '#16A34A',
  },
  success: '#22c55e',
  error: '#ef4444',
  accent: {
    DEFAULT: '#ffe500',
    foreground: '#000000',
  },
};
